export const API_URL = "https://api.ativity.com.br";
//export const API_URL = "http://192.168.15.7:3004";
